import { GET_DATA, SET_DEP, LOGIN, LOGOUT, NOTE_ASSIGNED } from "../type";

export const loginAction = (data) => ({ type: LOGIN, payload: data })
export const getDataAction = (data) => ({ type: GET_DATA, payload: data })
export const dpAction = (data) => ({ type: SET_DEP, payload: data })
export const logoutAction = () => ({ type: LOGOUT })
export const noteAssignedAction = (data) => ({ type: NOTE_ASSIGNED, payload: data })
export const setCuadernoPermission = (permiso) => ({
    type: "SET_CUADERNO_PERMISSION",
    payload: permiso,
});